export default __webpack_public_path__ + "static/media/vn-mezz-restaurant-sofitel-saigon-plaza.f2cc6ba5.jpg";